"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PendingRequestsTableGenerator = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _config = _interopRequireDefault(require("./config"));
var _styles = _interopRequireDefault(require("./styles"));
var _utils = _interopRequireDefault(require("../utils"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Generate a Pending Requests Table with the custom configuration
 * applied
 *
 * @param {object} [uiConfig]
 * @returns {object} { PendingRequestsTable }
 */
var PendingRequestsTableGenerator = function PendingRequestsTableGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var functions = uiConfig.functions;
  var getColumns = functions && typeof functions.getColumns === 'function' ? functions.getColumns : _config.default.functions.getColumns;
  var getOptions = functions && typeof functions.getOptions === 'function' ? functions.getOptions : _config.default.functions.getOptions;
  var getDefaultCustomFooter = functions && typeof functions.getDefaultCustomFooter === 'function' ? functions.getDefaultCustomFooter : _config.default.functions.getDefaultCustomFooter;
  var getDateInFormat = functions && typeof functions.getDateInFormat === 'function' ? functions.getDateInFormat : _config.default.functions.getDateInFormat;
  var CustomDataTable = functions && functions.CustomDataTable ? functions.CustomDataTable : _config.default.functions.CustomDataTable;
  var PendingRequestsTable = function PendingRequestsTable(_ref) {
    var classes = _ref.classes,
      content = _ref.content,
      tableSpec = _ref.tableSpec;
    var loading = content.loading,
      error = content.error,
      data = content.data;
    var options = getOptions(tableSpec, classes, getDefaultCustomFooter);
    if (loading) {
      return /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null);
    }
    if (error) {
      return /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "h5",
        color: "error",
        size: "sm"
      }, error ? "An error has occurred in loading component: ".concat(error) : 'Recieved wrong data');
    }
    var dateColumn = [];
    var draftColumns = getColumns(tableSpec, classes);

    // transform the datetime
    var customizedCloumns = [];
    for (var i = 0; i < draftColumns.length; i += 1) {
      if (draftColumns[i].name === 'requestDate') {
        dateColumn = [{
          name: 'requestDate',
          label: 'Request Date',
          options: {
            display: true,
            filter: false,
            customBodyRender: function customBodyRender(value) {
              return getDateInFormat(value, '/');
            }
          }
        }];
      } else {
        customizedCloumns.push(draftColumns[i]);
      }
    }
    var actionColumn = [{
      name: 'requestID',
      label: 'Action',
      options: {
        sort: false,
        customBodyRender: function customBodyRender(value) {
          var href = "/#/admin/review/".concat(value);
          return /*#__PURE__*/_react.default.createElement(_Button.default, {
            variant: "contained",
            component: _Link.default,
            href: href,
            classes: {
              root: classes.btn
            }
          }, "review");
        }
      }
    }];
    var columns = customizedCloumns.concat(dateColumn).concat(actionColumn);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 32
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(CustomDataTable, {
      data: data ? _utils.default.transformData(data.listRequest, tableSpec.columns) : [],
      columns: columns,
      options: options
    }))));
  };
  return {
    // @ts-ignore
    // eslint-disable-next-line max-len
    PendingRequestsTable: (0, _core.withStyles)(_styles.default, {
      withTheme: true
    })(PendingRequestsTable)
  };
};
exports.PendingRequestsTableGenerator = PendingRequestsTableGenerator;
var _default = PendingRequestsTableGenerator;
exports.default = _default;